// store.ts
import { createEntityEndpoints } from "@/core/factory/endpoints"
import { createEntitySelectors } from "@/core/factory/selectors"
import { createEntitySlice } from "@/core/factory/slice"
import { createEntityThunks } from "@/core/factory/thunks"
import { EntityWithId } from "@/core/factory/types"
import { Session } from "@/redux/_session.types"

export function createEntityStore<T extends EntityWithId, C>(
  entityName: string,
  defaultEntity: () => T,
  contextSelector: (state: any) => C,
  formatFn?: (entity: T, _session: Session, context: C) => T
) {
  const endpoints = createEntityEndpoints(entityName)
  const slice = createEntitySlice<T>(entityName, defaultEntity)
  const thunks = createEntityThunks<T>(entityName, endpoints, slice.actions)

  return {
    _reducer: slice.reducer,
    actions: slice.actions,
    thunks,
    endpoints,
    selectors: createEntitySelectors<T, C>(entityName, contextSelector, formatFn)
  }
}
